type Tone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

/** Maps an approvable status to a StatusPill tone. */
export function statusTone(status: string): Tone {
  switch (status) {
    case 'approved':
    case 'paid':
      return 'success';
    case 'declined':
      return 'danger';
    case 'sent':
      return 'info';
    case 'deferred':
      return 'warning';
    default:
      return 'neutral';
  }
}
